<script setup lang="ts">
import { computed, useSlots } from 'vue';

const props = withDefaults(
    defineProps<{
        variant?: 'default' | 'danger' | 'neutral';
        icon?: string | string[];
        text?: string;
    }>(),
    { variant: 'default' }
);

const slots = useSlots();

const computedClass = computed(() => {
    const variants: Record<string, string> = {
        default: 'bg-purple-lightest border-purple',
        danger: 'bg-danger-lightest border-danger',
        neutral: 'bg-gray-lightest border-gray-light'
    };
    return variants[props.variant];
});
</script>

<template>
    <span class="c-info-wrapper border py-2 px-3" :class="computedClass">
        <template v-if="!slots.default">
            <font-awesome-icon v-if="icon" :icon="icon" class="mr-2" />
            {{ text }}
        </template>
        <slot />
    </span>
</template>

<style scoped lang="scss">
@import '@/assets/css/utilities/functions';

.c-info-wrapper {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 0.5rem;
    &.border-danger {
        border-color: get-color('danger-light');
    }
    &.border-purple {
        border-color: get-color('purple-light') !important;
    }
    &.border-gray-light {
        border-color: get-color('gray-light') !important;
    }
}

.warning-alert {
    padding: 4px 8px;
    font-size: 1rem;
    background-color: get-color('orange-lightest');
    color: get-color('orange');
}
</style>
